export default __webpack_public_path__ + "static/media/menu_settings.ee5799fc.svg";